import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import './rollerBlindBoxSelector.scss';
import filter from "lodash/filter";
import find from "lodash/find";
import isUndefined from "lodash/isUndefined";

class RollerBlindBoxSelectorCtrl {
    constructor($sce, imagesService, dataService, apiService, $scope, $rootScope) {
        this.moreInfo = null;
        this.sce = $sce;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.apiService = apiService;
        this.selectedBoxId = null;
        this.selectedPaletteId = null;
        this.selectedColorId = null;
        this.colorOptions = [];
        this.colorsInSelectedPalette = [];
        this.paletteOptions = [];
        this.searchString = '';
    }

    isSelected(id) {
        return this.selectedBoxId === id;
    }

    /**
     * Reset button functionality
     */
    reset() {
        this.selectedBoxId = this.dataService.reset(
            this.defaultSelectedIdFieldName,
        );
        this.setColorPalettesForSelectedOption();
        this.selectDefaultColorPalette();
        this.getColorsFromSelectedPalette();
        this.selectDefaultColor();
    }

    onInit() {
        this.moreInfo = this.dataService.getMoreInfo(this.defaultSelectedIdFieldName);
        this.colorOptions =this.dataService.getAttributeOptions('colors');
        this.selectDefaultOption();
        this.setColorPalettesForSelectedOption();
        this.selectDefaultColorPalette();
        this.getColorsFromSelectedPalette();
        this.selectDefaultColor();
    }

    selectDefaultOption() {
        if (!this.selectedBoxId) {
            this.selectedBoxId = this.dataService.getSelectedOptionId(this.defaultSelectedIdFieldName);
        }
    }

    selectDefaultColorPalette() {
        this.selectedPaletteId = this.dataService.getSelectedOptionId('rollerBlindBoxColorPalette');

        if (!this.selectedPaletteId) {
            this.selectedPaletteId = this.paletteOptions[0].id;
        }
    }

    selectDefaultColor() {
        this.selectedColorId = this.dataService.getSelectedOptionId('rollerBlindBoxColor');

        if (!this.selectedColorId) {
            this.selectedColorId = this.colorsInSelectedPalette[0].id;
        }
    }

    selectColorPalette(id) {
        this.selectedPaletteId = id;
        this.getColorsFromSelectedPalette();
        this.dataService.updateSelectedOptions(
            'rollerBlindBoxColorPalette',
            [this.selectedPaletteId],
            'rollerBlindBoxColorPalette',
            false,
        );
    }

    selectColor(id) {
        this.selectedColorId = id;
        this.dataService.updateSelectedOptions(
            'rollerBlindBoxColor',
            [this.selectedColorId],
            'rollerBlindBoxColor',
            false,
        );
    }

    toggleSelected(id) {
        this.selectedBoxId = id;
        this.selectedOptions = [id];
        this.dataService.updateSelectedOptions(
            this.defaultSelectedIdFieldName,
            this.selectedOptions,
            this.options[0].type,
            true,
        );
        this.setColorPalettesForSelectedOption();
        this.selectDefaultColorPalette();
        this.getColorsFromSelectedPalette();
        this.selectDefaultColor();
    }

    setColorPalettesForSelectedOption() {
        let ids = this.options.find(option => { return option.id === this.selectedBoxId }).attributes.colorPalettes;
        this.paletteOptions = this.dataService.data.included.colorPalettes.filter(palette => ids.includes(palette.id));
    }

    getColorsFromSelectedPalette() {
        this.colorsInSelectedPalette = this.colorOptions.filter(el => el.attributes.paletteIds.indexOf(this.selectedPaletteId) > -1);
        const filteredColor = [];
        if (this.searchString != '') {
            const regExp = new RegExp(`${this.searchString.toLowerCase()}`);

            this.colorsInSelectedPalette.forEach((el) => {
                if (el.attributes.name.toLowerCase().match(regExp)) {
                    filteredColor.push(el);
                } else if (el.attributes.ral && el.attributes.ral.match(regExp)) {
                    filteredColor.push(el);
                }
            });
            this.colorsInSelectedPalette = filteredColor;
        }
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedBoxId = null;
    }

    getCaptionImage(type) {
        return this.imagesService.getCaptionImageUrl(this.defaultSelectedIdFieldName, type);
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    setImage($event, imgSrc) {
        $($event.target).parent().find('.rollerBlindBoxSelect__content-item-icon-hover').attr('src', this.getImage(imgSrc));
    }

    isNcs() {
        const colorPalettes = this.paletteOptions;
        const NCSPalettes = filter(colorPalettes, el => el.name.toUpperCase() === 'NCS');

        const NCSPalette = find(NCSPalettes, el => el.id === this.selectedPaletteId);

        return !isUndefined(NCSPalette);
    }
}

RollerBlindBoxSelectorCtrl.$inject = ['$sce', 'imagesService', 'dataService', 'handlesService', 'apiService', '$scope', '$rootScope'];

export default RollerBlindBoxSelectorCtrl;
